<template>
	<div>
		<div class="operation_box">
			<div class="operation_item">
				<template v-if="isNewOrExpired">
					<el-dropdown
						split-button type="primary"
						@click="showEditPutOptionModal"
						@command="(command) => command()"
						>
						<i class="fa fa-pencil"></i>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item :command="showEditPutOptionModal">
								<i class="fa fa-pencil"></i> {{ $t('common.edit') }}
							</el-dropdown-item>
							<el-dropdown-item :command="deletePutOption">
								<i class="fa fa-trash"></i> {{ $t('common.delete') }}
							</el-dropdown-item>
						</el-dropdown-menu>
						</el-dropdown>
				</template>

				<template v-if="isPublishedOrReadyToBeAccepted">
					<el-dropdown
						split-button type="primary"
						@click="showPutOptionDetails"
						@command="(command) => command()"
					>
						<i class="fa fa-search-plus"></i>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-if="hasOffers" :command="showPutOptionDetails">
								<i class="fa fa-search-plus"></i> {{ $t('debtorManagement.revolvingPutOption.putOptionTable.operation.reviewOffers') }}
							</el-dropdown-item>
							<el-dropdown-item :command="withdrawPutOption">
								<i class="fa fa-ban"></i> {{ $t('debtorManagement.revolvingPutOption.putOptionTable.operation.withdraw') }}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>

			</div>
		</div>
	</div>
</template>

<script>
import {enumDef} from "@/common/enumDefs";

export default {
	methods: {
		showEditPutOptionModal() {
			this.params.showEditPutOptionModal(this.params.data);
		},
		deletePutOption() {
			let option = {
				title: this.$t("debtorManagement.revolvingPutOption.deletePutOption.confirm.title"),
				msg: this.$t("debtorManagement.revolvingPutOption.deletePutOption.confirm.text"),
				confirmFun: () => {
					this.params.deletePutOption(this.params.data.id);
				}
			};
			this.confirmMeg(option, true);
		},
		showPutOptionDetails() {
			this.params.showPutOptionDetails(this.params.data);
		},
		withdrawPutOption() {
			let option = {
				title: this.$t("debtorManagement.revolvingPutOption.withdrawPutOption.confirm.title"),
				msg: this.$t("debtorManagement.revolvingPutOption.withdrawPutOption.confirm.text"),
				confirmFun: () => {
					this.params.withdrawPutOption(this.params.data.id);
				}
			};
			this.confirmMeg(option, true);
		},
	},
	computed: {
		hasOffers() {
			return this.params.data.offersCount > 0;
		},
		isNewOrExpired() {
			let status = this.params.data[this.params.statusField];
			return enumDef.revolvingPutOptionStatus.isNewOrExpired(status);
		},
		isPublishedOrReadyToBeAccepted() {
			let status = this.params.data[this.params.statusField];
			return enumDef.revolvingPutOptionStatus.isPublishedOrReadyToBeAccepted(status);
		}
	}
};
</script>